import i18n from "i18n";
import ViewTypeLabel from "views/components/ViewTypeLabel";
const UNSAVED_VIEW_TITLES = {
  SEARCH: "common_views.unsaved_view.search",
  DASHBOARD: "common_views.unsaved_view.dashboard"
};
const unsavedViewTitle = (type) => UNSAVED_VIEW_TITLES[type] ? i18n.t(UNSAVED_VIEW_TITLES[type], { ns: "search" }) : `Unsaved ${ViewTypeLabel({ type, capitalize: true })}`;
export default (title, type) => title != null ? title : unsavedViewTitle(type);
